export function getEnv() {
  if (typeof window === 'undefined') {
    // Node/SSR
    return {
      VITE_API_USER_ROOT_URL: process.env.VITE_API_USER_ROOT_URL,
      VITE_PARTNERS_BASE_URL: process.env.VITE_PARTNERS_BASE_URL,
      VITE_STATIC_ROOT_URL: process.env.VITE_STATIC_ROOT_URL,
      VITE_WEB_BASE_URL: process.env.VITE_WEB_BASE_URL,
      VITE_HELP_CENTRE_URL: process.env.VITE_HELP_CENTRE_URL,
      VITE_CDN_BASE_URL: process.env.VITE_CDN_BASE_URL,
      VITE_CDN_BASE_URL_USER_CONTENT: process.env.VITE_CDN_BASE_URL_USER_CONTENT,
      VITE_PRO_SIGN_UP_BASE_URL: process.env.VITE_PRO_SIGN_UP_BASE_URL,
      VITE_AWS_COGNITO_REGION: process.env.VITE_AWS_COGNITO_REGION,
      VITE_AWS_COGNITO_USER_POOL_ID: process.env.VITE_AWS_COGNITO_USER_POOL_ID,
      VITE_AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: process.env.VITE_AWS_COGNITO_USER_POOL_WEB_CLIENT_ID,
      VITE_AWS_COGNITO_IDENTITY_POOL_ID: process.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
      VITE_AWS_COGNITO_DOMAIN: process.env.VITE_AWS_COGNITO_DOMAIN,
      VITE_SENTRY_ENV: process.env.VITE_SENTRY_ENV,
      APP_ENV: process.env.APP_ENV,
      VITE_API_ROOT_URL: process.env.VITE_API_ROOT_URL,
      VITE_RECAPTCHA_SITE_KEY: process.env.VITE_RECAPTCHA_SITE_KEY,
      VITE_ROBOTS: process.env.VITE_ROBOTS,
      VITE_SPONSORED_PLACEMENT_CONFIG_URL: process.env.VITE_SPONSORED_PLACEMENT_CONFIG_URL,
    };
  } else {
    // Browser: read from global __APP_ENV__ injected by Vite
    return __APP_ENV__;
  }
}
